import Badge from "../Badge";

interface ListItemBadgeProps {
  text: string;
}

const ListItemBadge = ({ text }: ListItemBadgeProps) => (
  <div className="listItemBadge">
    <Badge text={text} />
  </div>
);

export default ListItemBadge;
